module.exports = __webpack_public_path__ + "static/media/iconfinder_ic_account_circle_48px_3669480.da9ef55c.svg";